import React from "react";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Link, useParams } from "react-router-dom";
import { useUser } from "../../../hooks/use-user";
import { errorToast } from "../../../utils/toast";
import axios from "../../../axios";
import { FaArrowRightLong } from "react-icons/fa6";
import Correct from "../../../Images/Vector.png";
import bgImage from "../../../Images/Section (2).png";
import Info from "../../../Images/ph_info-duotone.png";
import Table from "../../../componant/Table/Table";
import Cell from "../../../componant/Table/cell";
import UserNameLink from "../userControl/components/UserNameLink";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  InputGroup,
  InputLeftElement,
  Input,
  Button,
  InputRightAddon,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";

import { MdEdit, MdDelete } from "react-icons/md";
import { HiStatusOnline } from "react-icons/hi";
import { GrOverview } from "react-icons/gr";
function ContestJoinUser() {
  const { id } = useParams();
  const [newID, setNewID] = useState(null);
  const [data, setData] = useState([]);
  const [allContestUsers, setAllContestUsers] = useState([]);
  const [contestInfo, setContestInfo] = useState(null);
  console.log(data);
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const cancelRef = React.useRef();
  const btnRef = React.useRef();
  const [search, setSearch] = useState("");

  useEffect(() => {
    async function fetchData() {
      axios.get(`getAllUsersJoinedContest/${id}`).then((response) => {
        console.log(response?.data);

        if (response?.data) {
          const result = response?.data?.result;
          const users = Array.isArray(result)
            ? result
            : result?.user || result?.users || [];

          users.forEach((user) => {});
          setData(users);
          setContestInfo(Array.isArray(result) ? result?.[0] : result);
          console.log(response?.data?.result?.user?.mobile, "mobile numbers");
          //   localStorage.setItem("plans", JSON.stringify(response?.data?.result));
        }
      });
    }
    fetchData();
  }, []);
  const filteredData = useMemo(() => {
    if (!search) return data;

    return data.filter(
      (item) =>
        item?.user?.name?.toLowerCase().includes(search.toLowerCase()) ||
        item?.user?.email?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, data]);

  const formatDateTime = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const sendWhatsAppToAllUsers = async () => {
    try {
      const res = await axios.post("/sendContestMessageForAllJoinedUsers", {
        contestId: id,
        contestName: contestInfo?.contestName,
      });

      alert(res.data.message);
    } catch (err) {
      errorToast(err?.response?.data?.message);
    }
  };

  const sendWhatsAppMessage = async (userId) => {
    try {
      const res = await axios.post("/sendContestWhatsAppMessage", {
        userId,
        contestId: id,
        contestName: contestInfo?.contestName,
      });

      alert(res.data.message);
    } catch (err) {
      console.error(err);
      errorToast(
        err?.response?.data?.message || "Failed to send WhatsApp message",
      );
    }
  };

  const refundAllUsers = async () => {
    const confirmRefund = window.confirm(
      "Are you sure you want to refund all users?",
    );

    if (!confirmRefund) return;

    try {
      const res = await axios.post(`/contest/${id}/refund-all`);

      alert(res.data.message);

      // refresh table
      const response = await axios.get(`getAllUsersJoinedContest/${id}`);
      const result = response.data.result;
      setData(Array.isArray(result) ? result : result?.user || result?.users || []);
      setContestInfo(Array.isArray(result) ? result?.[0] : result);
    } catch (err) {
      errorToast(err?.response?.data?.message || "Refund failed");
    }
  };
  const refundSingleUser = async (user) => {
    const confirmRefund = window.confirm(`Refund ${user.user.name}?`);

    if (!confirmRefund) return;

    try {
      const res = await axios.post(`/contest-user/${user._id}/refund`);

      alert(res.data.message);

      const response = await axios.get(`getAllUsersJoinedContest/${id}`);

      const result = response.data.result;
      setData(Array.isArray(result) ? result : result?.user || result?.users || []);
      setContestInfo(Array.isArray(result) ? result?.[0] : result);
    } catch (err) {
      errorToast(err?.response?.data?.message || "Refund failed");
    }
  };
  const allRefunded = useMemo(() => {
    return (
      data.length > 0 && data.every((item) => item.refundStatus === "refunded")
    );
  }, [data]);

  const totalEntryCoins = useMemo(() => {
    return filteredData.reduce(
      (sum, item) => sum + Number(item?.entryCoin || 0),
      0,
    );
  }, [filteredData]);

  const contestName = contestInfo?.contestName || data?.[0]?.contestName;
  const contestDate = contestInfo?.createdOn || data?.[0]?.createdOn;

  const columns = React.useMemo(
    () => [
      {
        Header: "Sr No.",
        accessor: "srNo",
        Cell: ({ value, row: { index } }) => <Cell text={index + 1} />,
      },
      {
        Header: "User",
        accessor: "name",
        Cell: ({ value, row: { original } }) => (
          <>
            <UserNameLink
              userId={original?.user?._id || original?.user}
              name={original?.user?.name}
            />
            {/* <Cell subtext={`${original?.user?.mobile}`} /> */}
            {/* <div className="flex items-center justify-center gap-2 text-13 mt-2">
            <div className="flex gap-2 ">
            <div className="flex justify-center items-center gap-2">
              <div className="w-10 bg-green-600 rounded-full p-1 h-1 "></div>
              <h1 className="text-md font-bold text-green">
                {original?.rightCount}
              </h1>
            </div>
            <div className="flex justify-center items-center gap-2">
              <div className="w-10 bg-redC rounded-full p-1 h-1 "></div>
              <h1 className="text-md font-bold text-red">
                {original?.wrongCount}
              </h1>
            </div>
            <div className="flex justify-center items-center gap-2">
              <div className="w-10 bg-yellow-400 rounded-full p-1 h-1 "></div>
              <h1 className="text-md font-bold text-yellow-500">
                {original?.skipCount}
              </h1>
            </div>
          </div>
            
            </div> */}
          </>
        ),
      },
      // {
      //   Header: "Remaining Balance",
      //   accessor: "remaining",
      //   Cell: ({ value, row: { original } }) => (
      //     <>
      //       <Cell text={`Rs. ${Math.ceil(value)}`} />
      //     </>
      //   ),
      // },
{
  Header: "Mobile No.",
  accessor: "mobile",
  Cell: ({ row: { original } }) => (
    <a
      href={`tel:${original?.user?.mobile}`}
      className="text-blue-600 hover:underline cursor-pointer"
    >
      {original?.user?.mobile}
    </a>
  ),
},
      {
        Header: "EntryCoins",
        accessor: "entryCoin",
        Cell: ({ value, row: { original } }) => (
          <Cell text={original?.entryCoin} />
        ),
      },
     
      {
        Header: "Contest Balance ",
        accessor: "unifiedWallet.contestBalance",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={`${original?.user?.unifiedWallet.contestBalance}`} />
          </>
        ),
      },
       {
        Header: "Total Balance",
        accessor: "unifiedWallet",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={`${original?.user?.unifiedWallet?.balance}`} />
          </>
        ),
      },
      {
        Header: "Created On",
        accessor: "createdOn",
        Cell: ({ row: { original } }) => (
          <Cell text={formatDateTime(original.createdOn)} />
        ),
      },
      // {
      //   Header: "Total Earning (Rs)",
      //   accessor: "totalEarning",
      //   Cell: ({ value, row: { original } }) => <Cell text={`Rs. ${Math.ceil(value)}`} />,
      // },
      // {
      //   Header: "Wallet Balance (Rs.)",
      //   accessor: "currentEarning",
      //   Cell: ({
      //     value,
      //     row: {
      //       original: { rate, rightCount },
      //     },
      //   }) => {
      //     return <Cell text={`Rs. ${Math.round(rightCount * rate)}`} />;
      //   },
      // },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row: { original } }) => {
          return (
            <>
              <Menu>
                <MenuButton
                  as={Button}
                  className="bg-purple "
                  colorScheme="bgBlue"
                  onClick={() => setNewID(original._id)}
                >
                  Actions
                </MenuButton>
                <MenuList>
                  <Link to={`/dash/edit-course/${original._id}`}>
                    <MenuItem>
                      {" "}
                      <MdEdit className="mr-4" /> Edit
                    </MenuItem>
                  </Link>

                  <MenuItem onClick={onOpen2}>
                    {" "}
                    <HiStatusOnline className="mr-4" /> Hold User
                  </MenuItem>

                  <Link to={`/dash/view-question/${original._id}`}>
                    <MenuItem>
                      <GrOverview className="mr-4" /> Change Plan
                    </MenuItem>
                  </Link>
                  <MenuItem
                    onClick={() => sendWhatsAppMessage(original?.user?._id)}
                  >
                    📱 Send WhatsApp Message
                  </MenuItem>
                  <MenuItem
                    isDisabled={original.refundStatus === "refunded"}
                    onClick={() => refundSingleUser(original)}
                  >
                    {original.refundStatus === "refunded"
                      ? "✅ Refunded"
                      : "💰 Refund Credits"}
                  </MenuItem>
                </MenuList>
              </Menu>
            </>
          );
        },
      },
    ],

    [data],
  );

  return (
    <div
      className="lg:py-8 py-4 bg-bgBlue"
      style={{
        backgroundImage: `url('${bgImage}')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <section class=" md:p-1 ">
        <div class="py-4 ">
          <div className="mb-5 rounded-lg border border-purple/30 bg-white p-4 shadow-sm">
            <div className="grid gap-3 md:grid-cols-2">
              <div>
                <p className="text-xs font-semibold uppercase text-gray-500">
                  Contest Name :  {contestName || "Contest name not available"}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold uppercase text-gray-500">
                  Date :  {contestDate
                    ? dayjs(contestDate).format("D MMM, YYYY h:mm A")
                    : "Date not available"}
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex flex-wrap items-center gap-2">
              <Button
                colorScheme="green"
                onClick={async () => {
                  try {
                    const res = await axios.get(`exportContestUsers/${id}`);
                    alert(res.data.message);
                  } catch (err) {
                    console.error(err);
                    alert("Export Failed");
                  }
                }}
              >
                Export Users
              </Button>

              <Button colorScheme="green" onClick={sendWhatsAppToAllUsers}>
                Send WhatsApp Message
              </Button>
              <Button
                colorScheme="red"
                onClick={refundAllUsers}
                isDisabled={allRefunded}
              >
                {allRefunded ? "All Users Refunded" : "Refund All Users"}
              </Button>
              <div className="bg-white shadow rounded-lg px-6 py-4 min-w-[220px] border-l-4 border-purple-600">
                <p className="text-gray-500 text-sm">
                  Total Entry Coins :{totalEntryCoins.toLocaleString()}{" "}
                </p>
              
              </div>
            </div>
            <div className="w-full lg:w-96">
              <InputGroup borderRadius={5} size="sm" className="w-full">
                <InputLeftElement
                  pointerEvents="none"
                  // children={<Search2Icon color="gray.600" />}
                />
                <Input
                  type="text"
                  placeholder="Search..."
                  border="1px solid #949494"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <InputRightAddon p={0} border="none">
                  <Button
                    className="bg-purple"
                    colorScheme="#FF782D"
                    size="sm"
                    borderLeftRadius={0}
                    borderRightRadius={3.3}
                    border="1px solid #949494"
                  >
                    Search
                  </Button>
                </InputRightAddon>
              </InputGroup>
            </div>

            <div className="flex flex-wrap lg:flex-nowrap gap-2 w-full lg:w-auto">
              <Menu>
                <MenuButton
                  as={Button}
                  w={{ base: "100%", lg: "auto" }}
                  colorScheme="#4D2C5E"
                  className="bg-bgBlue"
                >
                  Sort By
                </MenuButton>
                <MenuList zIndex={20}>
                  <MenuItem>Download</MenuItem>
                  <MenuItem>Create a Copy</MenuItem>
                  <MenuItem>Mark as Draft</MenuItem>
                  <MenuItem>Delete</MenuItem>
                  <MenuItem>Attend a Workshop</MenuItem>
                </MenuList>
              </Menu>
              <Menu>
                <MenuButton
                  as={Button}
                  w={{ base: "100%", lg: "auto" }}
                  colorScheme="#FF782D"
                  className="bg-purple"
                  ref={btnRef}
                  onClick={onOpen2}
                >
                  Filter By
                </MenuButton>
              </Menu>
            </div>
            <Drawer
              isOpen={isOpen2}
              placement="right"
              onClose={onClose2}
              finalFocusRef={btnRef}
            >
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Create your account</DrawerHeader>

                <DrawerBody>
                  <Input placeholder="Type here..." />
                </DrawerBody>

                <DrawerFooter>
                  <Button variant="outline" mr={3} onClick={onClose2}>
                    Cancel
                  </Button>
                  <Button colorScheme="blue">Save</Button>
                </DrawerFooter>
              </DrawerContent>
            </Drawer>
          </div>
          <div className="mt-2">
            <Table
              // isLoading={isLoading}
              data={filteredData || []}
              columns={columns}
              // total={data?.total}
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContestJoinUser;
